import React, { useEffect, useState, useRef } from "react"
import { retrieveItemImageFromHero } from "../utilities"
import DfbCard from "../elements/dfb_card"
import CEpaperCard from "../elements/c_epaper_card"
import CFilterEnhanced from "../elements/c_filter_enhanced"
import CHighlightArticles from "../elements/c_highlight_articles"
import CSignupCard from "../elements/c_signup_card"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbButton from "../ui-kit/dfb_button"
import DfbAnchor from "../ui-kit/dfb_anchor"
import Masonry from "masonry-layout"
import Section from "./section"

const CardSwitch = ({ item, page_types_with_image }) => {
  switch (item.type) {
    case "epaper":
      return <CEpaperCard force_image_loading={true} data={item} />
    case "highlightArticles":
      return <CHighlightArticles data={item} add_class={item.add_class} />
    case "signupCard":
      return <CSignupCard />
    default:
      return (
        <DfbCard
          data={item}
          force_image_loading={true}
          page_types_with_image={page_types_with_image}
        />
      )
  }
}

const MFeedMasonry = ({
  data,
  collectionForPage,
  hasNextPage,
  totalCount,
  availableFilterOptions,
  setSelectedFilterOptions,
  handleNextPage,
  className,
}) => {
  const {
    uid,
    page_types_with_image,
    collection,
    filter_type,
    show_filter_control,
    headline,
    subheadline,
    anchorLink,
    anchorLabel,
  } = data

  const usableCollection = collectionForPage || collection

  const rootNodeRef = useRef(null)
  const feedNodeRef = useRef(null)

  useEffect(() => {
    if (typeof window !== "undefined" && feedNodeRef && feedNodeRef.current) {
      const cardsGrid = new Masonry(feedNodeRef.current, {
        itemSelector: ".m-Feed-card",
        columnWidth: ".m-Feed-card",
        initLayout: false,
      })
      cardsGrid.layout()
    }
  }, [usableCollection])

  if (usableCollection === undefined) {
    return null
  }

  return (
    <Section
      ref={rootNodeRef}
      baseClass="m-Feed m-Feed--mansory"
      className={className}
      defaultBgColor={"grey"}
      defaultPaddingTop="large"
      defaultPaddingBottom="extra-large"
      data={data}
    >
      <div className="m-Feed-wrapper">
        <div className="m-Feed-container">
          {(headline || subheadline || (anchorLink && anchorLabel)) && (
            <div className="c-Headline m-Feed-headline">
              {headline && (
                <DfbHeadline
                  headline={headline}
                  headline_level="h3"
                  add_class="c-Headline-strokeLine"
                />
              )}
              {subheadline && (
                <div className="c-Headline-subheadline">{subheadline}</div>
              )}
              {anchorLink && anchorLabel && (
                <DfbAnchor
                  tagName="a"
                  link={anchorLink}
                  text={anchorLabel}
                  secondary={true}
                  add_class="c-Headline-anchor"
                />
              )}
            </div>
          )}

          <CFilterEnhanced
            uid={uid}
            totalCount={totalCount}
            availableFilterOptions={availableFilterOptions}
            setSelectedFilterOptions={setSelectedFilterOptions}
          />

          <div className="m-Feed-content">
            <div className="m-Feed-cards" ref={feedNodeRef}>
              {usableCollection.map((item) => (
                <div key={item.uid} className="m-Feed-card">
                  <CardSwitch
                    item={item}
                    page_types_with_image={page_types_with_image}
                  />
                </div>
              ))}
            </div>
            {handleNextPage && hasNextPage && (
              <div className="m-Feed-loadMore u-Spacing-xxl">
                <DfbButton
                  onClick={() => {
                    handleNextPage()
                  }}
                  text="Mehr laden"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MFeedMasonry
